// Shared display maps for the threaded clinical messaging UI. Server enforces the vocabularies.
export const THREAD_STATUS = {
  OPEN: { label: 'Open', tone: 'neutral' },
  AWAITING_CLINICIAN: { label: 'Awaiting clinician', tone: 'pending' },
  AWAITING_REQUESTOR: { label: 'Awaiting requestor', tone: 'pending' },
  NEEDS_MORE_INFORMATION: { label: 'Needs information', tone: 'warn' },
  APPROVED: { label: 'Approved', tone: 'pass' },
  DECLINED: { label: 'Declined', tone: 'fail' },
  COMPLETED: { label: 'Completed', tone: 'pass' },
  CLOSED: { label: 'Closed', tone: 'neutral' },
};
export const URGENCY = {
  ROUTINE: { label: 'Routine', tone: 'neutral' },
  PRIORITY: { label: 'Priority', tone: 'warn' },
  URGENT: { label: 'Urgent', tone: 'fail' },
};
export const REQUEST_TYPES = {
  general: 'General',
  php_eligibility: 'PHP eligibility',
  physician_certification: 'Physician certification',
  php_escalation: 'PHP escalation',
  prior_authorization: 'Prior authorization',
  admission: 'Admission',
  treatment_plan: 'Treatment plan',
  billing_compliance: 'Billing / compliance',
};
export const CLINICIAN_ACTIONS = [
  'APPROVE',
  'DECLINE',
  'NEED_MORE_INFORMATION',
  'RETURN_FOR_CORRECTION',
  'ACKNOWLEDGE',
  'COMPLETE_CERTIFICATION',
];
export const ACTION_LABELS = {
  APPROVE: 'Approve',
  DECLINE: 'Decline',
  NEED_MORE_INFORMATION: 'Need more information',
  RETURN_FOR_CORRECTION: 'Return for correction',
  ACKNOWLEDGE: 'Acknowledge',
  COMPLETE_CERTIFICATION: 'Complete certification',
};
